import PropTypes from 'prop-types';

export const FILTER_ACTIVE_SHAPE = {
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};

export const FILTER_OPTION_SHAPE = {
  color: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};

export const FILTER_SHAPE = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape(FILTER_OPTION_SHAPE)).isRequired,
  type: PropTypes.string.isRequired,
};

export const GRANTS_SHAPE = { // eslint-disable-line import/prefer-default-export
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  awarded_on: PropTypes.string,
  started_on: PropTypes.string,
  ended_on: PropTypes.string,
  amount: PropTypes.string,
  grantees: PropTypes.arrayOf(PropTypes.shape({})),
  communities: PropTypes.arrayOf(PropTypes.string),
  challenges: PropTypes.arrayOf(PropTypes.string),
  programs: PropTypes.arrayOf(PropTypes.shape({})),
};

export const RESEARCH_ITEM = {
  id: PropTypes.number,
  slug: PropTypes.string,
  meta: PropTypes.shape({
    knight_foundation_krn_description: PropTypes.string,
    knight_foundation_krn_external_link: PropTypes.string,
    knight_foundation_krn_member: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    knight_foundation_krn_research_publish_date: PropTypes.string,
  }),
  excerpt: PropTypes.shape({
    rendered: PropTypes.string,
  }),
  title: PropTypes.shape({
    rendered: PropTypes.string,
  }),
};

export const HISTORY_SHAPE = {
  listen: PropTypes.func,
  push: PropTypes.func,
};

export const POST_LIST_ITEM_SHAPE = {
  byline: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  program: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  typeSingular: PropTypes.string.isRequired,
  themeColor: PropTypes.string.isRequired,
};
